module.exports = __webpack_public_path__ + "img/donationform.28d5d7e7.webp";